import Pagination from "../pagination/pagination";
import { auth } from "../services/auth";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import GeneralPopup from "../shared/GeneralPopup";
import ItemPreview from "../components/ItemsPreview";
import { Helmet } from "react-helmet";
import { getItems, fetchItem } from "../services/items";

export default function Items() {
  const [showPopup, setPopup] = useState(false);
  const [selectedRow, setSelectedRow] = useState();
  const [refresh, setRefresh] = useState(false);
  const isAdmin = auth().isAdmin();
  const token = auth().getToken();

  let PageSize = 20;
  let data = [];
  let totalRecords = 0;

  const [currentPage, setCurrentPage] = React.useState(1);
  const [post, setPost] = React.useState(null);

  const navigate = useNavigate();

  const itemConfig = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  if (!isAdmin) {
    navigate("/login");
  }

  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };

  useEffect(() => {
    getItems(currentPage, PageSize, config).then((response) => {
      setPost(response.data);
    });
  }, [currentPage, refresh]);

  if (post != null) {
    data = post?.data;
  }
  if (post?.totalRecords != null) {
    totalRecords = post?.totalRecords;
  }

  const togglePopup = (value) => {
    setPopup(!showPopup);
    setSelectedRow(data[value]);
  };

  const toggleRefresh = (value) => {
    if (value) {
      setRefresh(!refresh);
    }
  };

  const fetchItems = (event) => {
    event.preventDefault();
    if (
      window.confirm(
        "Are you sure you wanna fetch the items? It may result with rewriting of changed/updated fields."
      )
    ) {
      return fetchItem(itemConfig);
    }
  };

  return (
    <section className="my-20 px-3 lg:px-10">
      <Helmet>
        <title>Dailysocialboost | Items</title>
      </Helmet>
      <h2 className="text-xl font-bold my-10">Items</h2>
      <button
        className="my-5 px-20 py-3 w-80 self-start uppercase rounded-3xl text-white bg-pink-350 shadow-xl hover:opacity-90 transition-all"
        onClick={fetchItems}
      >
        Fetch
      </button>
      {data.length > 0 ? (
        <div className="grid grid-cols-12 gap-1">
          <div className="font-semibold flex flex-row items-center col-span-3">ID</div>
          <div className="font-semibold flex flex-row items-center">Panel ID</div>
          <div className="font-semibold flex flex-row items-center">Service</div>
          <div className="font-semibold flex flex-row items-center col-span-2">Name</div>
          <div className="font-semibold flex flex-row items-center">SEO Name</div>
          <div className="font-semibold flex flex-row items-center">Rate</div>
          <div className="font-semibold flex flex-row items-center">SEO Rate</div>
          <div className="font-semibold flex flex-row items-center">Service ID</div>
          <div className="font-semibold flex flex-row items-center"></div>
          <div className="col-span-12">
            <hr />
          </div>
          {data.map((item, idx) => (
            <React.Fragment key={item?.id}>
              <div className="grid grid-cols-12 col-span-12 gap-1 hover:bg-pink-100 transition-all">
                <div className="flex flex-row items-center col-span-3">{item.id}</div>
                <div className="flex flex-row items-center">{item.panelId}</div>
                <div className="flex flex-row items-center">{item.service}</div>
                <div className="flex flex-row items-center col-span-2">{item.name}</div>
                <div className="flex flex-row items-center">{item.seoExpertName}</div>
                <div className="flex flex-row items-center">{item.rate}</div>
                <div className="flex flex-row items-center">{item.seoExpertRate || "/"}</div>
                <div className="flex flex-row items-center">{item.serviceId}</div>
                <div className="flex flex-row items-center">
                  <button
                    className="font-semibold"
                    id={idx}
                    onClick={(e) => togglePopup(e.target.id)}
                  >
                    Edit
                  </button>
                </div>
              </div>
            </React.Fragment>
          ))}
        </div>
      ) : (
        <>No items yet!</>
      )}

      {showPopup ? (
        <GeneralPopup
          title={"Dailysocialboost Settings"}
          closePopup={togglePopup}
          popupData={selectedRow}
          handleRefresh={toggleRefresh}
        >
          <ItemPreview
            title={"Dailysocialboost Settings"}
            closePopup={togglePopup}
            popupData={selectedRow}
            handleRefresh={toggleRefresh}
          ></ItemPreview>
        </GeneralPopup>
      ) : null}
      <div className="mt-12">
        <Pagination
          className="pagination-bar"
          currentPage={currentPage}
          totalCount={totalRecords}
          pageSize={PageSize}
          onPageChange={(page) => setCurrentPage(page)}
        />
      </div>
    </section>
  );
}
